import React from 'react';

const iconProps = {
  width: 20,
  height: 20,
  stroke: 'currentColor',
  fill: 'none',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
};

export const CompassIcon = () => (
  <svg viewBox="0 0 24 24" {...iconProps}>
    <circle cx="12" cy="12" r="10" />
    <polygon points="12 8 16 16 8 16 12 8" fill="currentColor" stroke="none" />
  </svg>
);

export const MusicIcon = () => (
  <svg viewBox="0 0 24 24" {...iconProps}>
    <path d="M9 18V5l12-2v13" />
    <circle cx="6" cy="18" r="3" fill="currentColor" stroke="none" />
    <circle cx="18" cy="16" r="3" fill="currentColor" stroke="none" />
  </svg>
);

export const SpeakerIcon = () => (
  <svg viewBox="0 0 24 24" {...iconProps}>
    <polygon points="3 9 9 9 13 5 13 19 9 15 3 15 3 9" fill="currentColor" stroke="none" />
    <path d="M16 8a5 5 0 010 8" />
    <path d="M19 6a9 9 0 010 12" />
  </svg>
);

export const LeafIcon = () => (
  <svg viewBox="0 0 24 24" {...iconProps}>
    <path d="M5 21c14 0 14-16 14-16S5 5 5 21z" />
  </svg>
);

export const SparklesIcon = () => (
  <svg viewBox="0 0 24 24" {...iconProps}>
    <path d="M12 2l1.5 4.5L18 8l-4.5 1.5L12 14l-1.5-4.5L6 8l4.5-1.5L12 2z" fill="currentColor" stroke="none" />
    <path d="M19 16l.75 2.25L22 19l-2.25.75L19 22l-.75-2.25L16 19l2.25-.75L19 16z" fill="currentColor" stroke="none" />
  </svg>
);

export const PhoneIcon = () => (
  <svg viewBox="0 0 24 24" {...iconProps}>
    <rect x="7" y="2" width="10" height="20" rx="2" ry="2" />
    <line x1="12" y1="18" x2="12" y2="18" />
  </svg>
);

export const HeartIcon = ({ filled = false }) => (
  <svg viewBox="0 0 24 24" {...iconProps} fill={filled ? 'currentColor' : 'none'} stroke={filled ? 'currentColor' : 'currentColor'}>
    <path d="M12 21C12 21 4 13.5 4 8.5C4 5.42 6.42 3 9.5 3C11.24 3 12.91 3.81 14 5.09C15.09 3.81 16.76 3 18.5 3C21.58 3 24 5.42 24 8.5C24 13.5 16 21 16 21H12Z" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const SunIcon = () => (
  <svg viewBox="0 0 24 24" {...iconProps}>
    <circle cx="12" cy="12" r="5" />
    <line x1="12" y1="1" x2="12" y2="3" />
    <line x1="12" y1="21" x2="12" y2="23" />
    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
    <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
    <line x1="1" y1="12" x2="3" y2="12" />
    <line x1="21" y1="12" x2="23" y2="12" />
    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
    <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
  </svg>
);

export const MoonIcon = () => (
  <svg viewBox="0 0 24 24" {...iconProps}>
    <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" />
  </svg>
);

// Media control and utility icons
export const PlayIcon = () => (
  <svg viewBox="0 0 24 24" {...iconProps} fill="currentColor" stroke="none">
    <polygon points="5 3 19 12 5 21 5 3" />
  </svg>
);

export const PauseIcon = () => (
  <svg viewBox="0 0 24 24" {...iconProps} fill="currentColor" stroke="none">
    <rect x="6" y="4" width="4" height="16" />
    <rect x="14" y="4" width="4" height="16" />
  </svg>
);

export const DownloadIcon = () => (
  <svg viewBox="0 0 24 24" {...iconProps}>
    <path d="M12 5v14" />
    <polyline points="6 13 12 19 18 13" />
    <path d="M5 21h14" />
  </svg>
);

export const SpinnerIcon = () => (
  <svg viewBox="0 0 24 24" {...iconProps}>
    <circle
      cx="12"
      cy="12"
      r="10"
      strokeDasharray="31.4 31.4"
      strokeDashoffset="0"
    >
      <animateTransform
        attributeName="transform"
        type="rotate"
        from="0 12 12"
        to="360 12 12"
        dur="1s"
        repeatCount="indefinite"
      />
    </circle>
  </svg>
);

export const SearchIcon = () => (
  <svg viewBox="0 0 24 24" {...iconProps}>
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

export const CloseIcon = () => (
  <svg viewBox="0 0 24 24" {...iconProps}>
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

